import classNames from "classnames";
import React, { useRef, useState } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";

interface PasswordProps {
  register: UseFormRegisterReturn;
  label: string;
  errors: FieldError | undefined;
  id: string;
}

const Password: React.FC<PasswordProps> = ({ register, errors, label, id }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="my-2">
      <label className="mb-2 block text-sm dark:text-white">{label}</label>
      <div className="relative">
        <input
          id={id}
          {...register}
          type={showPassword ? "text" : "password"}
          className={classNames(
            "block w-full rounded-lg border-gray-200 py-3 pe-10 ps-4 transition-all duration-200 text-form-input focus:border-spkblue-base_color focus:ring-spkblue-base_color disabled:pointer-events-none disabled:opacity-50 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600",
            {
              "border-red-500 focus:border-red-500 focus:ring-red-500": errors,
            }
          )}
          placeholder="Enter password"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute inset-y-0 end-0 z-20 flex cursor-pointer items-center rounded-e-md px-3 text-gray-400 focus:text-spkblue-base_color focus:outline-hidden dark:text-neutral-600 dark:focus:text-spkblue-base_color"
        >
          <svg
            className="size-3.5 shrink-0"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              className={showPassword ? "hidden" : ""}
              d="M9.88 9.88a3 3 0 1 0 4.24 4.24"
            ></path>
            <path
              className={showPassword ? "hidden" : ""}
              d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
            ></path>
            <path
              className={showPassword ? "hidden" : ""}
              d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
            ></path>
            <line
              className={showPassword ? "hidden" : ""}
              x1="2"
              x2="22"
              y1="2"
              y2="22"
            ></line>
            <path
              className={showPassword ? "block" : "hidden"}
              d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
            ></path>
            <circle
              className={showPassword ? "block" : "hidden"}
              cx="12"
              cy="12"
              r="3"
            ></circle>
          </svg>
        </button>
      </div>
      {errors && (
        <p
          className="mt-2 text-sm text-red-600"
          id="hs-validation-name-error-helper"
        >
          {errors?.message}
        </p>
      )}
    </div>
  );
};

export default Password;
